// extracted by mini-css-extract-plugin
module.exports = {"root":"_c712d7","placeHolder":"_73c4f8","placeholderText":"_c36df1","popper":"_6024e3","enter":"_d24f7e","leave":"_c36e1c","from":"_8fa641","disabled":"_6571d3"};